import { render } from "./icon-grid.vue?vue&type=template&id=3d6f3efd"
import script from "./icon-grid.vue?vue&type=script&lang=js"
export * from "./icon-grid.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__